import React, { useMemo } from "react";
import "./styles.scss";
import { type HeadingProps } from "./KC_Heading1";

export default function KC_Heading3(props: HeadingProps) {
  const className = useMemo(() => {
    return `${props.primary ? "text-blue" : ""} ${
      props.secondary ? "text-secondary" : ""
    } ${props.className || ""} `;
  }, [props.primary, props.secondary, props.className]);

  return (
    <h3
      id={props.id}
      className={`kc-heading kc-heading-3 ${className}`}
      style={props.style}
    >
      {props.text}
    </h3>
  );
}
